var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow2Down(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27048 2.15317C2.58506 1.87792 3.09509 1.87792 3.40967 2.15317L7.67326 5.88382L11.9369 2.15317C12.2514 1.87792 12.7615 1.87792 13.076 2.15317C13.3906 2.42843 13.3906 2.87471 13.076 3.14997L8.24286 7.37901C7.92828 7.65426 7.41825 7.65426 7.10367 7.37901L2.27048 3.14997C1.9559 2.87471 1.9559 2.42843 2.27048 2.15317Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27048 6.85093C2.58506 6.57567 3.09509 6.57567 3.40967 6.85093L7.67326 10.5816L11.9369 6.85093C12.2514 6.57567 12.7615 6.57567 13.076 6.85093C13.3906 7.12618 13.3906 7.57246 13.076 7.84772L8.24286 12.0768C7.92828 12.352 7.41825 12.352 7.10367 12.0768L2.27048 7.84772C1.9559 7.57246 1.9559 7.12618 2.27048 6.85093Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2Down);
export default __webpack_public_path__ + "static/media/arrow_2_down.829e41f2cb32d80b7b8a8f471662e89f.svg";
export { ForwardRef as ReactComponent };